export default __webpack_public_path__ + "static/media/pantry2-before1-1440w.2fbffd95.png";